<div class="row h-100">
    <div class="col-9 p-0" >
        <div #chartTarget></div>
    </div>
    <div class="col-3 p-0 my-auto">
        <div class>
            <div *ngFor="let status of legend" class="clearfix mb-3">
                <div class="legend-rectangle float-left" 
                    [ngStyle]="{'background-color': status.statusFamilyColor + '80',
                                'border': '2px solid ' + status.statusFamilyColor }">
                </div>
                <div class="legend-text float-left">{{ status.statusFamilyName }}</div>
            </div>
        </div>
    </div>
</div>
